
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import CategoryMixin from "~/node_modules/sitis-nuxt/lib/mixins/CategoryMixin";
import {
  Product
} from "~/node_modules/sitisjs/dist/internal/sections/products/models/Product";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  name: "Category",

  head: function () {
    const description = this.category?.seo?.description || this.category?.metaDescription || "";
    let title = `Перевозка грузов до ${this.category?.name}`;
    if (this.category?.name === '20 - 100 тонн') {
      title = `Перевозка грузов от 20 до 100 тонн`
    }
    const city = this.$store.state?.appState?.config?.city?.data?.prepositional;
    // const fullTitle = [title, 'в', city].filter((t) => !!t).join(" ")
    const fullTitle = title;

    return {
      title: fullTitle,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(fullTitle, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },
  fetch: async function () {
    this.$store.commit('appState/setLoading', { category: true });
    this.$store.commit('catalog/setCategory', null);
    this.$store.commit('categoryFilters/setLoading', { key: 'get', value: true });
    this.$store.commit('categoryFilters/setFilters', []);
    await this.loadCategoryDetailed();
    await this.loadCategory(false);
    await this.getTransportList();
    this.$store.commit('appState/setLoading', { category: false });
  },

  data: function () {
    return {
      transportList: []
    }
  },

  components: {
    Breadcrumbs
  },

  mixins: [
    CategoryMixin
  ],

  computed: {
    breadcrumbs: function () {
      const categoryParent = this.category?.dynamicFields?.parent || {};

      let items = [
        { title: "Главная", path: "/" },
        { title: categoryParent?.name, path: "/gruzopodemnost" },
        { title: this.category?.name, path: this.$route.path },
      ];

      return items
    },

    afterCmsPageId: function () {
      return this.category?.dynamicFields?.after_cms_page_id || null
    },
    extensionsCategory: function () {
      return ['parent']
    },

    faqBlockValue: function () {
      return {
        categoryId: this.category?.id,

        useApi: true
      }
    },
    articlesBlockValue: function () {
      const tags = this.category?.dynamicFields?.news_tags || [];
      return {
        tags: tags,
        tagsVisibleCards: tags,
        isApi: Boolean(tags.length > 0)
      }
    },
    transportTypeSliderBlockValue: function () {
      let title = `Перевозка грузов до ${this.category?.name}`;
      if (this.category?.name === '20 - 100 тонн') {
        title = `Перевозка грузов от 20 до 100 тонн`
      }

      return {
        title: title,
        items: this.transportList,
        useH1: true
      }
    },
    directionsCompletedProjectsBlockValue: function () {
      const tags = this.category?.dynamicFields?.news_tags || [];
      return {
        tags: tags,
        tagsVisibleCards: tags,
        isApi: Boolean(tags.length > 0)
      }
    },
  },

  methods: {
    getTransportList: async function () {
      const requestUrl = `/categories/catalog/products?per-page=999&group=2&filter[gruzopodemnost]=${this.category?.slug}`;
      const response = await this.$api.agent.transport.get(requestUrl).then((res) => {
        return res.data
      }).catch(() => {
        return []
      });
      const products = response.map((t) => new Product(t));
      this.transportList = products;
    }
  }
}
